import request from '@/utils/request'

export function fetchTaskDetail(query) {
  return request({
    url: '/qa/task/detail',
    method: 'get',
    params: query
  })
}

export function fetchTmplList(query) {
  return request({
    url: '/template/manage/list',
    method: 'get',
    params: query
  })
}

export function fetchDemoCategory(query) {
  return request({
    url: '/demo/manage/categories',
    method: 'get',
    params: query
  })
}

export function createDemoItem(query) {
  return request({
    url: '/demo/manage/create',
    method: 'post',
    data: query
  })
}

export function updateDemoItem(query) {
  return request({
    url: '/demo/manage/update',
    method: 'post',
    data: query
  })
}

export function deleteDemoItem(query) {
  return request({
    url: '/demo/manage/delete',
    method: 'post',
    data: query
  })
}

export function fetchDemoList(query) {
  return request({
    url: '/demo/manage/list',
    method: 'get',
    params: query
  })
}

export function hideDemoList(query) {
  return request({
    url: '/demo/manage/hide',
    method: 'post',
    data: query
  })
}
